import { render, staticRenderFns } from "./ApplyQuota.vue?vue&type=template&id=3f6884ab&scoped=true"
import script from "./ApplyQuota.vue?vue&type=script&lang=ts"
export * from "./ApplyQuota.vue?vue&type=script&lang=ts"
import style0 from "./ApplyQuota.vue?vue&type=style&index=0&id=3f6884ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6884ab",
  null
  
)

export default component.exports